"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCityProperty = exports.cityPropertyDefinition = void 0;
exports.cityPropertyDefinition = {
    view: { label: 'City' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'city',
};
const isCityProperty = (prop) => {
    return prop.name === exports.cityPropertyDefinition.name;
};
exports.isCityProperty = isCityProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2l0eS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2NpdHkucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFO0lBQ3ZCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxNQUFNO0NBQ21CLENBQUE7QUFJMUIsTUFBTSxjQUFjLEdBQUcsQ0FBQyxJQUFrQixFQUF3QixFQUFFO0lBQ3pFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw4QkFBc0IsQ0FBQyxJQUFJLENBQUE7QUFDbEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxjQUFjLGtCQUUxQiJ9